import http from './http'

export function getPlatformDashboard(params = {}) {
  return http.get('platform-admin/dashboard', { params }).then((res) => res.data)
}
